<template>
  <div>
    <div class="row my-3">
      <div class="col-6">
        <ul class="nav nav-pills">
          <li
              v-for="(name, item) of views"
              :key="`drug-view-${item}`"
              class="nav-item">
            <a
                :class="`nav-link ${view === item ? 'active' : ''}`"
                @click="view = item">
              {{name}}
            </a>
          </li>
        </ul>
      </div>

      <div class="col-6">
      </div>
    </div>

    <div v-if="view === 'list'">
      <ClientDrugList
          :prescriptions="current"
          title="Текущие назначения" />

      <ClientDrugList
          :prescriptions="past"
          title="Прошлые назначения" />
    </div>

    <ClientDrugSchedule
        v-else-if="view === 'schedule'"
        :prescriptions="prescriptions"
        :times="times" />

    <ClientDrugShoplist
        v-else-if="view === 'shoplist'"
        :prescriptions="prescriptions" />
  </div>
</template>

<script>
import ClientDrugList from './drug2/List';
import ClientDrugSchedule from './drug2/Schedule';
import ClientDrugShoplist from './drug2/Shoplist';
import {MS_IN_DAY} from '../../constants';

export default {
  name: 'ClientDrug',

  components: {
    ClientDrugList,
    ClientDrugSchedule,
    ClientDrugShoplist,
  },

  props: ['client'],

  data() {
    return {
      loading: false,
      error: '',
      success: '',
      view: 'list',
      views: {
        list: 'Список',
        schedule: 'График приема',
        shoplist: 'Лист покупок',
      },
      showForm: false,
      prescriptionId: null,
    };
  },

  created() {
    this.loadData();
  },

  computed: {
    prescriptions() {
      const prescriptions = this.$store.getters.clientClinicDrugPrescriptions(this.client.id);

      return prescriptions.map(p => {
        const finishDate = new Date(p.finishDate);
        const startDate = new Date(p.startDate);
        const startedAt = p.startedAt === null? null : new Date(p.startedAt);
        const diff = finishDate.getTime() - startDate.getTime();
        const end = startedAt !== null
            ? startedAt.getTime() + diff + MS_IN_DAY
            : finishDate.getTime();

        p.isFinished = Date.now() > end && startedAt !== null;

        return p;
      });
    },

    prescription() {
      return this.prescriptions.find(i => i.id === this.prescriptionId)
    },

    current() {
      return this.prescriptions.filter(i => !i.isFinished);
    },

    past() {
      return this.prescriptions.filter(i => i.isFinished);
    },

    times() {
      return this.$store.state.times;
    },

    methods() {
      return this.$store.state.methods;
    },

    drugs() {
      return this.$store.state.drugs;
    },
  },

  methods: {
    async loadData() {
      try {
        this.loading = true;

        await Promise.all([
          this.$store.dispatch('CLINIC_LOAD_DRUG_PRESCRIPTIONS', this.client.id),
        ]);
      } catch (e) {
        this.error = e.message;
      }

      this.loading = false;
    },
  },
};
</script>
